const DEFAULT_POLYGON_OPACITY = 0.25;

export function normalizeOpacity(opacity?: number | nullish): number {
  if (typeof opacity !== 'number' || Number.isNaN(opacity)) {
    return DEFAULT_POLYGON_OPACITY;
  }

  return Math.max(0, Math.min(1, opacity));
}
